import { observer } from 'mobx-react';
import { Spinner } from '@teliaee/design-system';
import React from 'react';
import useStores from '../stores/UseStores';
import { API } from '../util/ApiUtil';
import { propagateWebApiState } from '../util/WebApiUtil';

const Logout = observer(() => {
  const { client } = useStores();

  const fetchWebApiResponse = async () => {
    await API.post('/logout/response').then((response) => {
      const model = response.data;
      propagateWebApiState(model);
      const handler = client?.handlers.find((handler) => handler.action === model.action);
      if (handler) {
        handler.callback(model);
      }
    });
  };

  if (!client) {
    window.location.replace('/ui/webapi/logout');
    return null;
  } else {
    fetchWebApiResponse();
  }

  return <Spinner />;
});

export default Logout;
